<template>
    <div id="siteHeader" class="c-site-header relative-position yb-layout-margin-header">
        <template>
            <div class="header-item item1 vrow items-stretch relative-position zh"  :class="{ 'mini': miniNormal==1,'normal':miniNormal!=1 }">
                <a class="vrow items-center img-logo-wrap" style="background-image: none;">
                    <template v-if="((account.showLogo && account.isApi) ||  !account.isApi ) && customTemplate">
                        <img :src="customTemplate['logo_wob-cn2']" v-if="(langId==2 || langId==3) && customTemplate['logo_wob-cn2'] && selectedTheme=='PM'" :style="customTemplate['logo_style_wob-cn2']">
                        <img :src="customTemplate['logo_wob-cn1']" v-if="(langId==2 || langId==3) && customTemplate['logo_wob-cn1'] && selectedTheme=='AM'" :style="customTemplate['logo_style_wob-cn1']">
                        <img :src="customTemplate['logo_wob-en2']" v-if="(langId!=2 && langId!=3) && customTemplate['logo_wob-en2'] && selectedTheme=='PM'" :style="customTemplate['logo_style_wob-en2']">
                        <img :src="customTemplate['logo_wob-en1']" v-if="(langId!=2 && langId!=3) && customTemplate['logo_wob-en1'] && selectedTheme=='AM'" :style="customTemplate['logo_style_wob-en1']">
                    </template>
                </a>
                <div class="site-nav vrow flex-nowrap col">
                    <div class="tab-wrap fit relative-position">
                        <div class="item-wrap relative-position" style="left: 0px;">
                            <div class="tab-item yb-flex-center tab-bet active">{{ langList.statementLang['STATEMENT.LBL_SPORTBET'] }}</div>
                            <div class="tab-item yb-flex-center tab-statement" @mouseover="highlightLine('statement')" @mouseleave="highlightLine('bet')" @click.prevent="showMoreFunc(1)">
                                {{langList.statement}}
                            </div>
                            <div class="tab-item yb-flex-center tab-result" @mouseover="highlightLine('result')" @mouseleave="highlightLine('bet')" @click.prevent="showMoreFunc(2)">
                                {{langList.result}}
                            </div>
                            <div  class="tab-item yb-flex-center tab-rules" @mouseover="highlightLine('rules')" @mouseleave="highlightLine('bet')" @click.prevent="showMoreFunc(5)">
                                {{ langList.statementLang['STATEMENT.LBL_SPORTRULES'] }}
                            </div>
                            <template v-if="lobby!='' && lobbyUrl!=''">
                                <div  class="tab-item yb-flex-center tab-lobby" @mouseover="highlightLine('lobby')" @mouseleave="highlightLine('bet')" @click.prevent="backToLobby()">
                                    {{ langList.home['HOME.LBL_LOBBY'] }}
                                </div>
                            </template>
                            <template v-if="promotionRulesShow && promotionRulesShow != null">
                                <div class="tab-item yb-flex-center tab-promotion promotion_header" @mouseleave="highlightLine('bet')" @click.prevent="showMoreFunc(8)">
                                    <div class="promotion_header_img"></div>
                                    <span class="promotion_header_title">{{langList.promotion['promotion.promotion_header']}}</span>
                                </div>
                            </template>
                            <template v-if="account.previewFlag && hasRedirect && customTemplate && customTemplate['redirect_web'] && customTemplate[(langId == 2 || langId == 3 ? 'redirect_cn' : 'redirect_en')] && loginRedirectUrl && showLobby()">
                                <div id="redirect_page" class="tab-item yb-flex-center tab-redirect" @click="redirectPage()">
                                    <img :src="customTemplate[(langId == 2 || langId == 3) ? 'redirect_cn' : 'redirect_en']['logo']" :style="{'width': customTemplate[(langId == 2 || langId == 3) ? 'redirect_cn' : 'redirect_en']['width_web']}">
                                </div>
                            </template>
                            <!--<div  class="tab-item yb-flex-center" @click.prevent="showMoreFunc(6)">
                                <img :src="selectedTheme=='AM' ? 'assets/images/foot_menubj-contact-white.gif' : 'assets/images/foot_menubj-contact-black.gif'" >
                            </div>-->
                            <div class="line-wrap pseudo">
                                <div class="line" style="transform: translateX(26px); width: 36px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <gameBanner :position="'t'" v-if="gameBannerStatus" :style="miniNormal!=1?'margin-right: -68px;':''"></gameBanner>
                <sliderImage v-else-if="miniNormal!=1"></sliderImage>
                <div v-if="miniNormal!=1" class="show-date-wrap relative-position">
                    <div class="show-date yb-family-odds">
                        <div class="date-item">
                            <span class="date-time">{{ currentTime }}</span>
                            <span class="time-zone">({{selectedTimeZone}})</span>
                        </div>
                    </div>
                </div>
                <div v-else-if="miniNormal==1" token="?token=d0cc5eb7db2c948b2592a117cb9081dcac4feefa" class="user-info rows">
                    <div class="vrow">
                        <div class="refresh-icon-wrap yb-flex-center">
                            <div class="c-refresh fit yb-flex-center cursor-pointer refresh-btn" @click="getSportCCL(0)">
                                <div class="icon-wrap" id="balancesRefresh">
                                    <i aria-hidden="true" role="presentation" class="q-icon icon-balance_refresh c-icon" style="font-size: 13px;"></i>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="c-refresh fit yb-flex-center cursor-pointer refresh-btn" @click="getSportCCL(0)">
                            <div class="icon-wrap" id="balancesRefresh">
                                <span class="icon-balance_refresh">
                                    <span class="path1"></span>
                                    <span class="path2" style="left:0px; position:absolute"></span>
                                    <span class="path3" style="left:0px; position:absolute"></span>
                                </span>
                            </div>
                        </div> -->
                        <div class="user-name" v-if="!account.previewFlag" @click="showMoreFunc(4)">Hi, {{ account.acccode }}</div>
                        <div class="user-name" v-else>Hi, Guest</div>
                    </div>
                    <div class="vrow">
                        <i aria-hidden="true" role="presentation"
                            class="balance-btn-eye balance-btn-eye2"
                            :class="showCCL ? 'icon-eye_show':'icon-eye_hide2'" style="font-size: 14px;"
                            @click="CCL"></i>
                        <div class="balance-text-hide" v-if="!showCCL"> ****** </div>
                        <div class="balance-text-show" v-else>{{ account.currCL | ccl(decimals) }}</div>
                    </div>
                </div>
            </div>

            <div class="header-item item2 vrow items-center" :style="leagueShowHide">
                <div class="yb-site-left-width "  :class="{ 'mini': miniNormal==1,'normal':miniNormal!=1 }">
                    <div class="search-wrap" @click="showSearchLeagueTeam()"  :class="{ 'mini': miniNormal==1,'normal':miniNormal!=1 }">
                        <div class="ellipsis" v-if="miniNormal!=1">
                            {{ langList.sportTableLang['SPORT_TABLE.LBL_SEARCH_LGETEAM'] }}
                        </div>
                        <span aria-hidden="true" role="presentation" class="icon q-icon c-icon " style="font-size: 14px;">
                            <img src="assets/images/search-icon.svg">
                        </span>
                    </div>
                </div>

                <div class="marquee-wrap col">
                    <div class="iframe-tab-wrapper iframe-tab-wrapper-left" style="display: none;">
                        <div class="tab-item">
                            {{ langList.sportTableLang['SPORT_TABLE.LBL_MYBETS'] }}
                        </div>
                        <div class="tab-item">{{ langList.result }}</div>
                    </div>
                    <div class="mlabel line-height">{{ langList.announceLanguage }}</div>
                    <div class="content col marquee cursor-pointer relative-position" @click.prevent="showMoreMsg(0)" >
                        <marquee behavior="scroll" direction="left" class="line-height fit"  onmouseout="this.start()" onmouseover="this.stop()"  v-html="content">Welcome !</marquee>
                        <!--div class="line-height" v-html="content"></div-->
                        <!--marquee scrollamount="40" onmouseout="this.start()" onmouseover="this.stop()" scrolldelay="1000"
                          class="line-height fit" v-html="content"></marquee-->
                    </div>
                </div>


                <div class="col-right vrow items-center" :style="{ 'width': right_widthPX + 'px'}">
                    <div v-if="miniNormal==1" class="show-date yb-family-odds col">
                        <div class="date-item">
                            <span class="date-time">{{ currentTime }}</span>
                            <span class="time-zone"v-if="timeZone.format!=1">({{ selectedTimeZone}})</span>
                        </div>
                    </div>
                    <div data-v-147931e8="" class="popup-wrap relative-position versions-zhuanye"
                        :class="{ 'active': showLangActive }">
                        <div data-v-147931e8="" class="language-text popup-text" :class="{ 'active': showLangActive }"
                            @click="clickShow('slang')">
                            <div :class="currentLang.language_code">
                                <span class="flag lang-active "></span>
                                <span class="lang-label ellipsis">{{currentLang.caption}}</span>
                            </div>
                            <div data-v-147931e8="" class="yb-icon-arrow"></div>
                        </div>
                        <div data-v-147931e8="" class="wrap-language" v-if="showLangActive">
                            <div data-v-147931e8="" class="triangle"></div>


                            <template v-for="(langData, langKey) in langSelect">
                                <!--div v-if="langData.id != 4 "-->
                                <div data-v-147931e8="" @click="changeLanguage(langData.id)" class="item ellipsis" :class="{'active': langData.caption == currentLang.caption}">
                                    <div :class="langData.language_code">
                                        <span data-v-147931e8="" class="flag"></span>{{ langData.caption }}
                                    </div>
                                </div>
                                <!--/div-->
                            </template>
                        </div>
                    </div>
                    <div data-v-0e13a278="" class="popup-wrap odds_dropdown showOddsActive" :class="{ 'active': showOddsActive }">
                        <div data-v-0e13a278="" class="text-wrap" @click="clickShow('sodds')">
                            <div data-v-0e13a278="" class="popup-text" title="">{{ oddTypesList[selectedOdd.toUpperCase()].lang }}</div>
                            <div data-v-0e13a278="" class="yb-icon-arrow"></div>
                        </div>
                        <div data-v-0e13a278="" class="relative-position odds_dropdown">
                            <div data-v-0e13a278="" class="item-wrap" style="width: min-content;">
                                <template v-for="odd in oddTypesList">
                                    <div data-v-0e13a278="" class="item " style="width: 100%; text-align:left;" @click="changeOdd(odd.key, $event)" :class="{'active':selectedOdd == odd.key}">{{ odd.lang }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="popup-wrap stheme" :class="{ 'active': showThemeActive }">
                        <div class="text-wrap" @click="clickShow('stheme')">
                            <div class="popup-text" :class="{ 'active': showThemeActive }">
                                <template v-if="selectedTheme == 'AM'">
                                    {{ langList.am }}
                                </template>
                                <template v-else>
                                    {{ langList.pm }}
                                </template>
                            </div>
                            <div class="yb-icon-arrow"></div>
                        </div>
                        <div class="relative-position">
                            <div class="item-wrap">
                                <div class="triangle"></div>
                                <div class="item ellipsis" :class="{ active: (selectedTheme == 'AM') }"
                                    @click="changeTheme('AM')">{{ langList.am }}</div>
                                <div class="item ellipsis" :class="{ active: (selectedTheme == 'PM') }"
                                    @click="changeTheme('PM')">{{ langList.pm }}</div>
                            </div>
                        </div>
                    </div>
                    <div data-v-0e13a278="" class="popup-wrap TimeZone_dropdown showTimeZoneActive" :class="{ 'active': showTimeZoneActive }" v-if="timeZone.format==1">
                        <div data-v-0e13a278="" class="text-wrap" @click="clickShow('sTime')">
                            <div data-v-0e13a278="" class="popup-text" title="">{{ selectedTimeZone}}</div>
                            <div data-v-0e13a278="" class="yb-icon-arrow"></div>
                        </div>
                        <div data-v-0e13a278="" class="relative-position TimeZone_dropdown">
                            <div data-v-0e13a278="" class="item-wrap" style="width: min-content;">
                                <template v-for="(dt , index)  in timeZone.list">
                                    <div data-v-0e13a278="" class="item " style="width: max-content;" @click="changeTimeZone(index, $event)" :class="{'active':selectedTimeZone == index}">{{ index }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import moment from 'moment'
import EventBus from '../../../events/event-bus'
import sportMatchCount from '@/vue/mixins/sportMatchCount'
import vueCookie from 'vue-cookie'
import sliderImage from './sliderImage'
import gameBanner from '../contentsLeft/gameBanner'

import {
    mapGetters
} from 'vuex'
export default {
    mixins: [sportMatchCount],
    components: {
        sliderImage,
        gameBanner
    },
    computed: {
        ...mapGetters([
            'langList',
            'account',
            'timeZone',
            'tvIconFlag',
            'oddTypesList',
            'miniNormal',
            'selectedMarket',
            'selectedBettype',
            'selectedMatchAllBet',
            'selectedSport',
            'showFavEvents',
            'showLeagueSearch',
            'showLeagueSearch',
            'showLeagueTeam',
            'frameWidthHeight',
            // 'sortedMatchEventList',
            'sportList',
            'promotionDetails',
        ]),
        right_widthPX: function () {
            return this.$store.getters.frameWidthHeight.width.RightPage_current
        },
        decimals: function () {
            return this.account._showDecimals ? 2 : 0
        },
        showLogo: function () {
            return this.account.showLogo
        },

        showFavEvents: {
            get() {
                return this.$store.getters.showFavEvents
            },
            set(value) {
                if (!this.account.previewFlag) {
                    EventBus.$emit('refreshOdd', true)
                    this.$store.dispatch('getSportOdds', {
                        showfavorite: value,
                        callback: ((res) => {
                            //   this.refreshTimer()
                            this.refreshScroll()
                        }).bind(this)
                    })
                }
            }
        },
        leagueShowHide: function(){
            var a = ''
            if(this.$store.getters.showLeagueTeam){
                a = 'z-index: 900'
            }
            return a
        },
    },
    data() {
        return {
            selectedOdd: null,
            currentTime: null,
            tdyDateTime: window.tdyDateTime,
            currentDate: null,
            langId: window._langid,
            langSelect: lang_select,
            currentLang: null,
            cookielang: _cookie,
            timerCount: 60,
            timerIdCount: null,
            cookielang: _cookie,
            content: "",
            openHeader: true,
            lobby: window.lobby,
            lobbyUrl: window.lobbyUrl,
            showLangActive: false,
            showThemeActive: false,
            selectedTheme: window.def_theme,
            showOddsActive: false,
            oddsTypeActive: false,
            reconnectTimerSeconds: 5,
            // hoverHeader: "bet",
            customTemplate: window._customTemplate,
            normaltable: false,
            rbtable: false,
            showCCL: true,
            selectedTimeZone: null,
            showTimeZoneActive:false,
            promotionRulesShow:window.promotionRulesShow,
            gameBannerStatus: (window._gameBanner || window._imageBanner)? true:false,
            redirectReq: window._redirectReq,
            hasRedirect: window._hasRedirect,
            loginRedirectUrl: window._loginRedirectUrl,
        }
    },
    methods: {
        CCL(){
            if(this.showCCL == true){
                this.showCCL = false;
            }else{
                this.showCCL = true;
            }
        },
        getSportCCL(loadAction) {
            if (!this.account.previewFlag) {
                $('#balancesRefresh').addClass('loading-static-animation')
                var active = $('.widgetPanel.personalAccount').hasClass('active')
                if (loadAction == 0 || (loadAction == 1 && active)) {
                    if (active) {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5,
                            showB: true,
                        })
                    } else {
                        this.$store.dispatch('getSportCCL', {
                            token: token.arr_5,
                        })
                    }
                }
            }
            setInterval(function () {
               
            }, 1500)
        },
        showSearchLeagueTeam(){
            EventBus.$emit("getLatestFilterEventList", true);
            this.$store.commit('SHOW_LEAGUETEAM', !this.$store.getters.showLeagueTeam);
            this.$store.commit('SHOW_LEAGUESEARCH',true);
            $('#searchField').focus()
        },
        toggleActive() {
            this.showLangActive = false
            this.showThemeActive = false
            this.showOddsActive = false
            this.oddsTypeActive = false
            this.showTimeZoneActive = false
        },
        clickShow(types) {
            // this.toggleActive()
            if (types == 'slang') {
                this.showLangActive = (this.showLangActive) ? false : true;
            } else if(types == 'oddsType') {
                this.oddsTypeActive = (this.oddsTypeActive) ? false : true;
            } else if (types == 'sodds') {
                this.showOddsActive = (this.showOddsActive) ? false : true;
            } else if (types == 'stheme') {
                this.showThemeActive = (this.showThemeActive) ? false : true;
            } else if (types == 'sTime') {
                this.showTimeZoneActive = (this.showTimeZoneActive) ? false : true;
            }

        },
        changeTheme(t) {
            var theme = 1
            if(t == 'PM'){
                theme = 2
            }else if(t == 'AM'){
                theme = 1
            }
            
            if (window.windowInfo != undefined) {
                window.windowInfo.close()
            }
            var a = 'theme01'
            if (t == 'PM') {
                a = 'theme02'
                document.documentElement.classList.add('theme02');
                $(document.body).addClass('theme02');
                $(document.body).removeClass('theme01');
            }else{
                document.documentElement.classList.remove('theme02');
                $(document.body).addClass('theme01');
                $(document.body).removeClass('theme02');
                
            }
            
            this.selectedTheme = t
            if (!this.account.previewFlag) {
                this.$ajax({
                    url: _baseUrl + '/account-def-settings',
                    type: 'get',
                    data: {
                        action: 'updateAccountSportSetting',
                        theme: theme
                    }
                }).done(response => {
                    
                })
            } else {
                $.ajax({
                    method: 'post',
                    url: _baseUrl + '/callCookies',
                    async: false,
                    data: {
                        action: 'theme',
                        theme: a,
                    },
                }).done((res) => {
                    
                })
            }
            // vueCookie.set('theme', a);
            this.showThemeActive = false
        },
        getTheme() {
            if (this.selectedTheme = 'AM') {
                // this.selectedTheme = 'AM'
                var disp = this.langList.am
            } else {
                // this.selectedTheme = 'PM'
                var disp = this.langList.pm
            }

            return disp
        },
        refreshTimer() {
            this.clearTimer()
            this.timerSeconds = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 180
            this.startTimer()
        },
        refreshScroll() {
            var main = document.getElementById('right_div');
            var sportTableWidth = $('.tableContent').outerWidth();
            if (main) {
                var maxTop = main.parentNode.parentNode.scrollHeight - main.offsetHeight;

                main.parentNode.parentNode.onscroll = function () {
                    main.style.top = Math.min(this.scrollTop + 39) + "px";
                    main.style.left = sportTableWidth + "px";
                }
            }
        },
        updateCurrentTime() {
            // this.currentTime = moment().zone("-04:00").format("HH:mm:ss").toString();
            var timeZone='-04:00'
            if(this.$store.getters.timeZone.list[this.selectedTimeZone]!=undefined){
                timeZone=this.$store.getters.timeZone.list[this.selectedTimeZone][0]
            }
            this.currentTime = moment().utcOffset(timeZone).format("HH:mm:ss").toString();
        },
        openLiveTv() {
            if (!this.account.previewFlag) {
                window.windowTv = window.open('livetv', 'MsgWindow', 'width=1050, height=700')
            }
        },
        showMoreMsg(msg) {
            if (!this.account.previewFlag) {
                window.windowInfo = window.open('annhistory?ann=' + msg, 'MsgWindow', 'width=1024, height=767');
            } else if (window._hasRedirect) {
                $('.login-redirect-dialog').show();
            }
        },
        showMoreFunc(msg) {
            if (!this.account.previewFlag) {
                let height = window.screen.availHeight - 50;
                let width = window.screen.availWidth - 100;
                var left = (screen.width/2)-(width/2);
                var top = (screen.height/2)-(height/2);
                if (width > 1024) {
                    width = 1024;
                }
                if(height>600){
                    height=600
                }
                if (msg == 0) {
                    window.windowInfo =window.open('sport-wager?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top='+top+', left='+left); //wgrTyp=openBet&page=1&sprtId=99
                } else if (msg == 1) {
                    window.windowInfo =window.open('statement?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top='+top+', left='+left);
                    // window.open('statement/summary/99/0/7/1', 'MsgWindow',  'width='+width+', height='+height+'');
                } else if (msg == 2) {
                    width = 1319;
                    window.windowInfo = window.open('event-results?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top='+top+', left='+left);
                } else if (msg == 5){
                    window.windowInfo =window.open('sport-information?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top='+top+', left='+left)
                } else if (msg == 4) {
                    window.windowInfo =window.open('account-settings?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top='+top+', left='+left)
                } else if (msg == 7 || msg == 6) {
                    let langsPost=1;
                    let pgss= msg == 7? 1:2;
                    if(this.currentLang.id==2){
                        langsPost=3;
                    }else if(this.currentLang.id==2){
                        langsPost=3
                    }else if(this.currentLang.id==3){
                        langsPost=4
                    }else if(this.currentLang.id==5){
                        langsPost=2
                    }
                    window.open('https://sigma23.3swolf.com/views/page.php?pg='+pgss+'&acc=' + this.account.acccode+'&lang='+langsPost, 'MsgWindow', 'width=' + width + ', height=' + height + ', top='+top+', left='+left)
                } else if(msg == '8') { //show promotion rules
                    window.windowInfo = window.open('event-results?c=' + msg, 'MsgWindow', 'width=' + width + ', height=' + height + ', top='+top+', left='+left);
                    window.addEventListener('message', (event) => {
                        if (event.source === window.windowInfo) {
                            const data = event.data;
                            if(data.redirectToPromotionSport) {
                                window.windowInfo.close();
                                // go to promotion sport eg today soccer
                                if(this.$store.getters.promotionDetails.length > 0 || Object.keys(this.$store.getters.promotionDetails).length > 0){
                                    var promo_sp_id = this.$store.getters.promotionDetails.sp_sport.split(",")
                                    var promo_sp_wager_type = this.$store.getters.promotionDetails.sp_wager_type.split(",")
                                    this.$store.commit('SELECTED_MARKET', parseInt(promo_sp_wager_type[0]))
                                    var promo_sport = this.$store.getters.sportList.find((element) => element.sprtId == 'N'+promo_sp_id[0]);
                                    EventBus.$emit('leftBarChangeSport', promo_sport); 
                                }
                                // location.reload();
                                data.redirectToPromotionSport = false;
                            }
                        }
                    });
                }
            } else if (window._hasRedirect) {
                $('.login-redirect-dialog').show();
            }
        },
        str_concate(a, b) {
            return a + b;
        },
        changeLanguage: function (value) {
            if (window.windowInfo != undefined) {
                window.windowInfo.close()
            }
            if (value == this.currentLang.id) {
                return false;
            }
            $('#loading-root-ele').show()
            this.$ajax({
                method: 'get',
                url: '',
                data: {
                    language: value,
                    token: token.arr_3,
                },
            }).done(response => {
                var url = window.location.href
                // if (url.indexOf('preview') != -1) {
                //     window.location.href = _baseUrl + '/preview'
                // } else {
                //     window.location.reload();
                // }

                //if url has param langs, eg. preview?sport=2&langs=3&ot=2&hdp=0
                if (url.indexOf('langs') != -1) {
                    var url_temp = url.split("langs") // [0]:preview?sport=2&' [1]:'=3&ot=2&hdp=0'
                    // check if the last char of first part url after split has '&', if yes remove '&'
                    var new_url = url_temp[0].slice(-1) == '&'? url_temp[0].slice(0, -1) : url_temp[0]
                    // check if the second part url after split contains others params by checking '&'
                    if(url_temp[1].indexOf('&') != -1) {
                        var url_rest = url_temp[1].split(/&(.*)/) // get the rest param, eg. '=3&ot=2&hdp=0' => 'ot=2&hdp=0'
                        window.location.href = new_url + (new_url.slice(-1) == '?'? '':'&') + url_rest[1]
                    } else {
                        window.location.href = new_url
                    }
                } else {
                    window.location.reload();
                }
            })
        },
        showLogout() {
            if (this.account.previewFlag) {
                return false
            }
            if (this.account.isApi && !this.account.showDemo) {
                return false
            }
            return true;
        },
        logout() {
            if (window.windowTv != undefined) {
                window.windowTv.close()
            }
            if (window.windowInfo != undefined) {
                window.windowInfo.close()
            }
            this.$ajax({
                method: 'post',
                url: _baseUrl + '/login',
                data: {
                    action: 'logout',
                    enableLoading: false,
                    token: token.arr_10,
                },
            }).done(((res) => {
                window.location.href = 'login'
            }).bind(this)).catch((errRes) => {
                console.log(errRes)
            })
            // window.location.href = this.url.loginUrl
        },
        ajaxForAnn(token_val = '') {
            var url = '';
            this.clearTimer();
            if (!this.account.previewFlag) {
                // url = "/annhistory/getAnn?selAnn=0&selDate=-0&langId="+this.currentLang.id
                url = "/annhistory/getAnn?selAnn=0&selDate=all&langId=" + this.currentLang.id
                //url = '/annhistory/getContLeftAnn';
                this.$ajax({
                    url: _baseUrl + url,
                    type: 'get',
                    data: {
                        langId: window._langid,
                        token: token_val,
                    },
                }).done(response => {
                    let msg = '';
                    if (response['data'].length > 0) {
                        let self = this;
                        response['data'].forEach(function (urgAnn) {
                            msg += self.replaceText(urgAnn['message'], 0) + "&nbsp;&nbsp;&nbsp;&nbsp;";
                            // alert(self.replaceText(urgAnn['message'],0));
                        });
                    }
                    this.content = msg;
                    this.timerCount = 180;
                    this.startTimer();
                    /*
                    if(response['data'] != -1){
                        if(response['data']['message'] != -1){
                            this.content = response['data']['message'];
                            //alert(this.content)
                            this.timer = 60;
                            this.startTimer();
                        }
                    }*/
                })
            } else {
                this.content = lang.welcome;
            }
        },
        clearTimer() {
            if (this.timerIdCount != null) {
                clearInterval(this.timerIdCount);
                this.timerIdCount = null;
            }
        },
        startTimer() {
            if (this.timerIdCount == null) {
                this.timerIdCount = setInterval(() => {
                    if (this.timerCount - 1 < 0) {
                        this.ajaxForAnn(token.arr_1);
                    } else {
                        this.timerCount -= 1;
                    }
                }, 1000);
            }
        },
        ajaxUrgentAnn() {
            this.$ajax({
                url: _baseUrl + '/annhistory',
                type: 'get',
                data: {
                    action: 'getUrgentAnn',
                    langId: window._langid
                }
            }).done(response => {

                if (response['data'].length > 0) {
                    let self = this;
                    response['data'].forEach(function (urgAnn) {
                        alert(self.replaceText(urgAnn, 0));
                        // alert(self.replaceText(urgAnn['message'],0));
                    });
                }

            })
        },
        ajaxFirstloadAnn() {
            this.$ajax({
                url: _baseUrl + '/annhistory',
                type: 'get',
                data: {
                    action: 'getFirstLoadAnn',
                    langId: window._langid
                }
            }).done(response => {
                if (response['data']['urg'].length > 0) {
                    let self = this;
                    var urgText = ''
                    response['data']['urg'].forEach(function (urgAnn, index) {
                        urgText += index + 1 + ') ' + urgAnn + '\n'
                    });
                    alert(urgText);
                }
                if (response['data']['left']) {
                    if (response['data']['left']['message']) {
                        this.content = response['data']['left']['message'];
                    }
                }
                this.timerCount = 60;
                this.startTimer();
            })
        },
        getMarketTimer(selMarket){
            if(selMarket == this.$store.getters.market.inPlayMarket.key){
            return this.rbTimer
            } else if (selMarket == this.$store.getters.market.earlyMarket.key){  
            return this.earlyTimer
            } else if(selMarket == this.$store.getters.market.tdyMarket.key){
            return this.todayTimer
            }
        },
        changeTimeZone(selectedTimeZone) {
            if (window.windowInfo != undefined) {
                window.windowInfo.close()
            }
            this.selectedTimeZone = selectedTimeZone;
            this.$store.commit('TIME_ZONE', this.selectedTimeZone)
            $('.TimeZone_dropdown').removeClass('active')
        },
        changeOdd(orderkey, event) {
            if (!this.account.previewFlag) {
                this.$ajax({
                    url: _baseUrl + '/account-def-settings',
                    type: 'get',
                    data: {
                        action: 'updateAccountSportSetting',
                        odd: orderkey
                    }
                }).done(response => {
                    
                })
            }
            // this.reloadingPer='0%';
            this.reloading = true
            event.preventDefault()
            event.stopPropagation()

            this.oddsTypeActive = false
            this.selectedOdd = orderkey
            this.$store.commit('SELECTED_ODD', orderkey)
            this.$store.commit('SHOW_UP_DOWN', false)
        //  this.$store.commit('CHANGE_ODDS', true)
            EventBus.$emit('cancelBetForm');
            EventBus.$emit('REMOVE_ALL_FORECAST');

            this.$store.commit('R_ALLBET_RELOADING', true);
            if(this.selectedMatchAllBet){
                EventBus.$emit('refreshAllbetTable', token.arr_4); 
                // this.$store.dispatch('getMatchAllBet', { 
                //     event: this.$store.getters.sortedMatchEventList,
                //     token: token.arr_4,
                //     callback: ((res) => {
                //         this.reloading = false
                //         this.oddsReload = false
                //         this.refreshScroll()
                //     }).bind(this)
                // })
            } else {
                EventBus.$emit('selectLeagueRefreshTable', token.arr_4);
                // selectLeagueRefreshTable
                // this.reloadTable(token.arr_4)
                // this.reloadRBTable(token.arr_4)
                if(this.$store.getters.show_Unfold || (this.selectedBettype && this.selectedBettype.sprtId!='N1') || this.$store.getters.simpleSport) {
                    EventBus.$emit('refreshRightScoreBoard', token.arr_4);
                }
            }
            
            $('.odds_dropdown').removeClass('active')
        },

        replaceText(words, repBool) {

            var blue_start = '[blue]';
            var blue_end = '[/blue]';
            var red_start = '[red]';
            var red_end = '[/red]';

            if (repBool == 0) {
                var blue_replace_start = '';
                var red_replace_start = '';
                var end = '';
            } else {
                var blue_replace_start = '<span style="color:blue">';
                var red_replace_start = '<span style="color:red">';
                var end = '</span>';
            }

            if (words) {
                if (words.indexOf(blue_start) != -1) {
                    words = words.replace('[blue]', blue_replace_start);
                }
                if (words.indexOf(blue_end) != -1) {
                    words = words.replace('[/blue]', end);
                }
                if (words.indexOf(red_start) != -1) {
                    words = words.replace('[red]', red_replace_start);
                }
                if (words.indexOf(red_end) != -1) {
                    words = words.replace('[/red]', end);
                }
            }
            return words
        },
        showLobby() {
            if (this.lobby != '' && this.lobbyUrl != '') {
                if (this.lobby != null && this.lobbyUrl != null) {
                    return true
                }
            }
            return false
        },
        backToLobby() {
            if(window.self !== window.top){
                window.top.location.href =this.lobbyUrl
            }else{
                window.location.href = this.lobbyUrl
            }
        },
        highlightLine(val){
            var position = $(".tab-"+val).first().position();
            var center =  position.left + ($(".tab-"+val).width()+30)/2 - 18;
            $('.site-nav .line').css('transform','translateX('+ center +'px)')
        },
        redirectPage(){
            let url = this.customTemplate['redirect_web'];
            if (this.redirectReq) {
                let req = this.redirectReq.split('&');
                _.each(req, function(val) {
                    if (!val.includes('prefix')) {
                        url += '&' + val;
                    }
                })
            }
            window.location.href = url
        },
    },
    created() {
        // this.currentTime = moment().zone("-04:00").format("HH:mm:ss").toString();
        var timeZone='-04:00'
        if(this.$store.getters.timeZone.list[this.selectedTimeZone]!=undefined){
            timeZone=this.$store.getters.timeZone.list[this.selectedTimeZone][0]
        }
        this.currentTime = moment().utcOffset(timeZone).format("HH:mm:ss").toString();
        setInterval(() => this.updateCurrentTime(), 1 * 1000);

        
        // this.currentDate = moment().format('ll');
    },
    mounted() {
        
        this.normaltable= false,
        this.rbtable= false,
        this.ajaxForAnn(token.arr_7);
        let Vue=this
        $(document).on('click', function (e) {
            if(Vue.showLangActive){
                if ($(e.target).closest(".wrap-language").length === 0 && $(e.target).closest(".language-text").length === 0) {
                    Vue.showLangActive=false;
                }
            }
            if(Vue.showThemeActive){
                if ($(e.target).closest(".stheme").length === 0) {
                    Vue.showThemeActive=false;
                }
            }
            if(Vue.showOddsActive){
                if ($(e.target).closest(".showOddsActive").length === 0) {
                    Vue.showOddsActive=false;
                }
            }
        });
    },
    watch: {
        // hoverHeader:function(val){
        //     var center = 26
        //     if(this.hoverHeader=='statement'){
        //         var position = $(".tab-statement").first().position();
        //         var center =  position.left + $(".tab-statement").width()/2 - 18;
        //     }else if(this.hoverHeader=='result'){
        //         var position = $(".tab-result").first().position();
        //         var center =  position.left + $(".tab-result").width()/2 - 18;
        //     }else if(this.hoverHeader=='rules'){
        //         var position = $(".tab-rules").first().position();
        //         var center =  position.left + $(".tab-rules").width()/2 - 18;
        //     }
        //     $('.site-nav .line').css('transform','translateX('+ center +'px)')
        // }
    },
    destroyed() {
        this.clearTimer()
    },
    beforeMount() {
        this.selectedOdd = this.$store.getters.account.oddsType
        if (this.hasRedirect) {
            var theme = 'theme02';
        } else {
            var theme = 'theme01';
        }
        if (this.selectedTheme == 'PM') {
            theme = 'theme02'
            document.documentElement.classList.add('theme02');
            $(document.body).addClass('theme02');
            $(document.body).removeClass('theme01');
        } else if (this.selectedTheme == 'AM') {
            theme = 'theme01'
            document.documentElement.classList.add('theme01');
            $(document.body).addClass('theme01');
            $(document.body).removeClass('theme02');
        }
            

        if (!vueCookie.get('theme')) {
            $.ajax({
                method: 'post',
                url: _baseUrl + '/callCookies',
                async: false,
                data: {
                    action: 'theme',
                    theme: theme
                },
            }).done((res) => {
                
            })
            // vueCookie.set('theme', theme)
        } else {
            if (vueCookie.get('theme') == 'theme01') {
                this.selectedTheme = 'AM'
            } else {
                this.selectedTheme = 'PM'
            }
        }

        _.map(this.langSelect, (langObj, key) => {
            _.assign(langObj, { id: key })
            return langObj
        })
        var selectedLangKey = _.findKey(this.langSelect, ((langObj) => {
            return langObj.language_code == this.cookielang
        }).bind(this))
        this.currentLang = this.langSelect[selectedLangKey]
        this.langSelect = _.filter(this.langSelect, (langObj, key) => {
            return langObj.language_code != this.cookielang
        })
        this.langSelect.unshift(this.currentLang)
        if (vueCookie.get(this.$store.getters.account.acccode+'_timeZone') && false) {
            let tms= JSON.parse(vueCookie.get(this.$store.getters.account.acccode+'_timeZone'))
            this.selectedTimeZone = tms.default;
        }else{
            this.selectedTimeZone = this.$store.getters.timeZone.default;
        }
        
    }

}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/myheader/wob_index.vue